import { Expose } from "class-transformer";
import { IsBoolean, IsNumber, IsString } from "class-validator";

export class TemporaryFileId {
  @IsNumber()
  @Expose()
  id!: number;
  @IsString()
  @Expose()
  name!: string;
  @IsBoolean()
  @Expose()
  canEdit!: boolean;
  @IsNumber()
  @Expose()
  type!: number;
  @IsBoolean()
  @Expose()
  sendWithInvoice!: boolean;
}
export type TemporaryFileResponse = Array<TemporaryFileId>;
